/**
 * amazon-cognito-identity-js (used by @curbnturf/auth's CognitoService) expects
 * a Node-style `global` object. Browsers don't have one — mirrors the same
 * shim apps/curbnturf/src/polyfills.ts already carries for the same reason.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window;
